module.exports = __webpack_public_path__ + "img/img-3.a48f7d61.png";